import { FC } from "react";

import { SimpleGrid, createStyles } from "@mantine/core";

import { Header } from "@components/Header/Header";
import { Content } from "@components/Content/Content";

import { ChangePassword } from "./components/ChangePassword";
import { GeneralInformation } from "./components/GeneralInformation";

const useStyles = createStyles((t) => ({
  grid: {
    rowGap: 40,
    gridTemplateColumns: "1fr minmax(1fr, 500px)",
  },
}));

export const SettingsRoute: FC = () => {
  const { classes } = useStyles();

  return (
    <>
      <Header />
      <Content>
        <SimpleGrid cols={2} className={classes.grid}>
          <GeneralInformation />
          <ChangePassword />
        </SimpleGrid>
      </Content>
    </>
  );
};
